import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from "framer-motion";
import "../sass/pages/_card_service.scss";

const CardService = ({ id, title, cover, alt }) => {
    const navigate = useNavigate()
    const handleClick = () => {
        navigate('/tarif', { replace: true });
    }
    return (
        <motion.div
            className='card_service'
            id={id}
            whileHover={{ scale: .85 }}
            whileFocus={{ scale: 0.9 }}
            whileTap={{ scale: 0.8 }}
            transition={{
                ease: "easeInOut", duration: .3
            }}
            onClick={handleClick}
        >
            <img src={cover} alt={alt} />
            <p>{title}</p>
        </motion.div>
    )
}
export default CardService;